import React from "react";
import { createPortal } from "react-dom";
import PreLoader from "../../ChatApp/components/PreLoader";

const Preloader = () => createPortal(<PreLoader />, document.body);

export default Preloader;
